"use client";
import * as React from "react";
const SvgClearSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.07 4.8 8 6.87 5.93 4.8 4.8 5.93 6.87 8 4.8 10.07l1.13 1.13L8 9.13l2.07 2.07 1.13-1.13L9.13 8l2.07-2.07zM8 0a8 8 0 1 0-.01 15.99A8 8 0 0 0 8 0m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4" }));
export {
  SvgClearSharp as default
};
